// extracted by mini-css-extract-plugin
module.exports = {"ImputWrapper":"Toggle_ImputWrapper__ChIpa","inputtogle":"Toggle_inputtogle__XugrP","spantogle":"Toggle_spantogle__3Bx37"};